import { useDispatch } from "react-redux";
import Footer from "../../SharedModule/components/Footer";
import { verifyModuleAccess } from "../../SharedModule/utils/accessUtils";
import { Spinner } from "../../SharedModule/components/Spinner";
import {
  CLIENTS_ADMIN_ACCESS,
  ROUTE_CLIENTS,
} from "../../SharedModule/utils/constants";
import { ForbiddenPage } from "../../SharedModule/pages/ForbiddenPage";
import { Link, useNavigate } from "react-router";
import { useEffect, useState } from "react";
import { BiLeftArrowAlt } from "react-icons/bi";
import { NewClient } from "../types/clients-module-types";
import { ClientsService } from "../services/clients";
import { addToast } from "../../SharedModule/redux/reducers/ui.reducer";
import { YES_NO_OPTIONS, NEW_CLIENT } from "../utils/clientsUtils";
import { SelectItemBoolean } from "../../SharedModule/types/shared-module-types";
import { ClientFormFields } from "../components/ClientFormFields";
import { useClientNewClient } from "../hooks/useClientNewClient";
import { setNeedRefresh } from "../redux/reducers/clientsList.reducer";
import { resetScrollY } from "../../SharedModule/utils/pagesUtils";

export const ClientNewClientPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    isLoadingDropdownInfo,
    isAllUsersWithProfileLoading,
    userRolesList,
    rolesLoaded,
    dropdownsValues,
    allUsers,
  } = useClientNewClient();

  useEffect(() => {
    document.title = "The Hub - New Client";

    return () => {
      resetScrollY(globalThis.location.pathname);
    };
  }, []);

  useEffect(() => {
    if (dropdownsValues) {
      let tempInvoiceFormatId = 0,
        tempRelationshipTypeId = 0,
        tempIndustryTypeId = 0,
        tempSourceTypeId = 0,
        tempBillingCycleId = 0,
        tempBillingTermId = 0,
        tempTaxJurisdictionId = 0;

      setActualCountry(
        dropdownsValues?.countries.find(
          (country) => country.label === clientProfile.countryName
        )
      );
      setActualState(
        dropdownsValues?.states.find(
          (state) => state.label === clientProfile.stateName
        )
      );
      setInvoiceFormat(
        dropdownsValues?.invoiceFormats.find((format) => {
          if (format.label === clientProfile.invoiceFormatName) {
            tempInvoiceFormatId = format.value;
            return format;
          }
        })
      );
      setRelationshipType(
        dropdownsValues?.relationshipTypes.find((type) => {
          if (type.label === clientProfile.relationshipTypeName) {
            tempRelationshipTypeId = type.value;
            return type;
          }
        })
      );
      setIndustryType(
        dropdownsValues?.industryTypes.find((type) => {
          if (type.label === clientProfile.industryTypeName) {
            tempIndustryTypeId = type.value;
            return type;
          }
        })
      );
      setSourceType(
        dropdownsValues?.sourceTypes.find((type) => {
          if (type.label === clientProfile.sourceTypeName) {
            tempSourceTypeId = type.value;
            return type;
          }
        })
      );
      setBillingCycle(
        dropdownsValues?.billingCycles.find((cycle) => {
          if (cycle.label === clientProfile.billingCycleName) {
            tempBillingCycleId = cycle.value;
            return cycle;
          }
        })
      );
      setBillingTerm(
        dropdownsValues?.billingTerms.find((cycle) => {
          if (cycle.label === clientProfile.billingTermName) {
            tempBillingTermId = cycle.value;
            return cycle;
          }
        })
      );
      setTaxJurisdiction(
        dropdownsValues?.taxJurisdictions.find((tax) => {
          if (tax.label === clientProfile.taxJurisdictionName) {
            tempTaxJurisdictionId = tax.value;
            return tax;
          }
        })
      );
      setReferredBy(
        dropdownsValues?.referralTypes.find((type) => {
          if (type.label.toLowerCase() === "internal") {
            return type;
          }
        })
      );

      setClientProfile({
        ...clientProfile,
        invoiceFormatId: tempInvoiceFormatId,
        relationshipTypeId: tempRelationshipTypeId,
        industryTypeId: tempIndustryTypeId,
        sourceTypeId: tempSourceTypeId,
        billingCycleId: tempBillingCycleId,
        billingTermId: tempBillingTermId,
        taxJurisdictionId: tempTaxJurisdictionId,
      });
    }
  }, [dropdownsValues]);

  const [clientProfile, setClientProfile] = useState<NewClient>(NEW_CLIENT);
  const [actualCountry, setActualCountry] = useState<any>(undefined);
  const [actualState, setActualState] = useState<any>(undefined);
  const [companyOwner, setCompanyOwner] = useState<any>(undefined);
  const [invoiceFormat, setInvoiceFormat] = useState<any>(undefined);
  const [relationshipType, setRelationshipType] = useState<any>(undefined);
  const [industryType, setIndustryType] = useState<any>(undefined);
  const [sourceType, setSourceType] = useState<any>(undefined);
  const [billingCycle, setBillingCycle] = useState<any>(undefined);
  const [billingTerm, setBillingTerm] = useState<any>(undefined);
  const [taxJurisdiction, setTaxJurisdiction] = useState<any>(undefined);
  const [leadGenerationSourceTypeId, setLeadGenerationSourceTypeId] =
    useState<any>(undefined);
  const [referredBy, setReferredBy] = useState<any>(undefined);
  const [customMasterAgreement, setCustomMasterAgreement] =
    useState<any>(undefined);
  const [customNda, setCustomNda] = useState<any>(undefined);

  const [currentClient] = useState<SelectItemBoolean>(
    YES_NO_OPTIONS.find(
      (option) => option.value === clientProfile.currentClient
    ) || YES_NO_OPTIONS[0]
  );
  const [comprehensiveCareClient, setComprehensiveCareClient] = useState<
    SelectItemBoolean | undefined
  >(
    YES_NO_OPTIONS.find(
      (option) => option.value === clientProfile.comprehensiveCareClient
    )
  );
  const [continuousInnovationClient, setContinuousInnovationClient] = useState<
    SelectItemBoolean | undefined
  >(
    YES_NO_OPTIONS.find(
      (option) => option.value === clientProfile.continuousInnovationClient
    )
  );
  const [purchaseOrderRequired, setPurchaseOrderRequired] = useState<
    SelectItemBoolean | undefined
  >(
    YES_NO_OPTIONS.find(
      (option) => option.value === clientProfile.purchaseOrderRequired
    )
  );
  const [useAuthorization, setUseAuthorization] = useState<
    SelectItemBoolean | undefined
  >(
    YES_NO_OPTIONS.find(
      (option) => option.value === clientProfile.useAuthorization
    )
  );
  const [taxable] = useState<SelectItemBoolean | undefined>(
    YES_NO_OPTIONS.find((option) => option.value === clientProfile.taxable)
  );

  const [createButtonDisabled, setCreateButtonDisabled] = useState(true);

  useEffect(() => {
    const isDisabled =
      clientProfile.companyName.length === 0 ||
      !companyOwner ||
      clientProfile.streetAddress.length === 0 ||
      clientProfile.city.length === 0 ||
      !actualState ||
      clientProfile.postalCode.length === 0 ||
      !actualCountry ||
      clientProfile.priceSchedule === 0 ||
      !relationshipType ||
      !industryType ||
      !sourceType ||
      !billingCycle ||
      !billingTerm ||
      !taxable ||
      !taxJurisdiction ||
      !invoiceFormat;

    setCreateButtonDisabled(isDisabled);
  }, [
    clientProfile.companyName,
    companyOwner,
    clientProfile.streetAddress,
    clientProfile.city,
    actualState,
    clientProfile.postalCode,
    actualCountry,
    clientProfile.priceSchedule,
    relationshipType,
    industryType,
    sourceType,
    billingCycle,
    billingTerm,
    taxable,
    taxJurisdiction,
    invoiceFormat,
  ]);

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.target;

    setClientProfile((prevData) => {
      if (!prevData) return prevData;
      return {
        ...prevData,
        [name]: value,
      };
    });
  };

  const handleChangeDropdown = (name: string, elem: any) => {
    // Add extra logic here for dropdowns to keep update profile state
    switch (name) {
      case "companyOwnerUserId":
        setCompanyOwner(elem);
        setClientProfile({
          ...clientProfile,
          companyOwnerUserId: elem.value,
        });
        break;
      case "comprehensiveCareClient":
        setComprehensiveCareClient(elem);
        setClientProfile({
          ...clientProfile,
          comprehensiveCareClient: elem.value,
        });
        break;
      case "continuousInnovationClient":
        setContinuousInnovationClient(elem);
        setClientProfile({
          ...clientProfile,
          continuousInnovationClient: elem.value,
        });
        break;
      case "purchaseOrderRequired":
        setPurchaseOrderRequired(elem);
        setClientProfile({
          ...clientProfile,
          purchaseOrderRequired: elem.value,
        });
        break;
      case "useAuthorization":
        setUseAuthorization(elem);
        setClientProfile({
          ...clientProfile,
          useAuthorization: elem.value,
        });
        break;
      case "customNda":
        setCustomNda(elem);
        setClientProfile({
          ...clientProfile,
          customNdaId: elem.value,
        });
        break;
      case "invoiceFormatId":
        setInvoiceFormat(elem);
        setClientProfile({
          ...clientProfile,
          invoiceFormatId: elem.value,
        });
        break;
      case "leadGenerationSourceTypeId":
        setLeadGenerationSourceTypeId(elem);
        setClientProfile({
          ...clientProfile,
          leadGenerationSourceTypeIds: elem,
        });
        break;
      case "referredTypeId":
        setReferredBy(elem);
        setClientProfile({
          ...clientProfile,
          referredBy: elem.value,
        });
        break;
      case "customMasterAgreementId":
        setCustomMasterAgreement(elem);
        setClientProfile({
          ...clientProfile,
          customMasterAgreement: elem.value,
        });
        break;
    }
  };

  const create = async () => {
    const {
      leadGenerationSourceTypeIds,
      referredBy,
      customMasterAgreement,
      billingCycleName,
      billingTermName,
      industryTypeName,
      invoiceFormatName,
      relationshipTypeName,
      sourceTypeName,
      taxJurisdictionName,
      countryName,
      stateName,
      ...rest
    } = clientProfile;

    const cloned = {
      ...rest,
      leadGenerationSourceTypeIds:
        clientProfile.leadGenerationSourceTypeIds.map((type) => type.value),
      referralTypeId:
        clientProfile.referredBy !== 0 ? clientProfile.referredBy : null,
      customMasterAgreementId:
        clientProfile.customMasterAgreement !== 0
          ? clientProfile.customMasterAgreement
          : null,
      customNdaId:
        clientProfile.customNdaId !== 0 ? clientProfile.customNdaId : null,
      // set countryId & stateId mannually
      stateId: actualState.value,
      countryId: actualCountry.value,
    };

    await ClientsService.addInternalClient(cloned)
      .then((res) => {
        dispatch(setNeedRefresh(true));
        dispatch(
          addToast({
            mode: "success",
            message: res.message,
          })
        );
        navigate(ROUTE_CLIENTS);
      })
      .catch((err) => {
        dispatch(
          addToast({
            mode: "error",
            message:
              err.data.errors[err.data.errors.length - 1] ??
              "Something went wrong creating this internal client",
          })
        );
      });
  };

  return (
    <div className="content">
      {(!rolesLoaded ||
        isLoadingDropdownInfo ||
        isAllUsersWithProfileLoading) && (
        <Spinner
          style={{
            marginLeft: "50%",
            marginTop: "5%",
          }}
        />
      )}

      {rolesLoaded &&
        !isLoadingDropdownInfo &&
        !isAllUsersWithProfileLoading &&
        !verifyModuleAccess(true, CLIENTS_ADMIN_ACCESS, userRolesList) && (
          <ForbiddenPage />
        )}

      {rolesLoaded &&
        !isLoadingDropdownInfo &&
        !isAllUsersWithProfileLoading &&
        verifyModuleAccess(true, CLIENTS_ADMIN_ACCESS, userRolesList) && (
          <>
            <Link
              className="back-button-container text-decoration-none mt-2"
              to={ROUTE_CLIENTS}
            >
              <BiLeftArrowAlt className="back-button-arrow" />
              <span className="back-button-text">Back to Client List</span>
            </Link>
            <div
              className="content-header"
              style={{ marginTop: "0", marginBottom: "1rem" }}
            >
              <h2>Add New Client</h2>
            </div>

            <form className="card entry-hour-box-background px-4 py-2 my-3">
              <ClientFormFields
                allUsers={allUsers}
                isAllUsersWithProfileLoading={isAllUsersWithProfileLoading}
                dropdownsValues={dropdownsValues}
                clientProfile={clientProfile}
                handleChange={handleChange}
                handleChangeDropdown={handleChangeDropdown}
                currentClient={currentClient}
                companyOwner={companyOwner}
                actualState={actualState}
                actualCountry={actualCountry}
                relationshipType={relationshipType}
                industryType={industryType}
                sourceType={sourceType}
                referredBy={referredBy}
                leadGenerationSourceTypeId={leadGenerationSourceTypeId}
                comprehensiveCareClient={comprehensiveCareClient}
                continuousInnovationClient={continuousInnovationClient}
                purchaseOrderRequired={purchaseOrderRequired}
                useAuthorization={useAuthorization}
                customMasterAgreement={customMasterAgreement}
                customNda={customNda}
                billingCycle={billingCycle}
                invoiceFormat={invoiceFormat}
                billingTerm={billingTerm}
                taxable={taxable}
                taxJurisdiction={taxJurisdiction}
                submitButton={
                  <div className="d-flex p-0 my-3">
                    <button
                      className="btn btn-primary"
                      type="button"
                      onClick={() => create()}
                      disabled={createButtonDisabled}
                    >
                      Create
                    </button>
                  </div>
                }
              />
            </form>
          </>
        )}
      <Footer />
    </div>
  );
};
